import { FC, ReactNode } from 'react';
import styles from './LoadingModal.module.scss';
import loadingImg from './loading.png';
import { Themes, useTheme } from '@maxtropy/components';

interface Props {
  loading: boolean;
  content: ReactNode;
}

const LoadingModal: FC<Props> = props => {
  const { loading, content } = props;
  const theme = useTheme();

  if (!loading) return <></>;

  return (
    <div
      className={styles.wrap}
      style={{ background: theme === Themes.DARK ? 'rgba(0, 0, 0, 0.5)' : 'rgba(0, 0, 0, 0.1)' }}
    >
      <div
        className={styles.contentWrap}
        style={{ background: theme === Themes.DARK ? 'linear-gradient(180deg, #2a2a2a 0%, #1f1f1f 100%)' : '#FFF' }}
      >
        <div className={styles.topLine}></div>
        <img src={loadingImg} className={styles.loadingImg} />
        <div>{content}</div>
      </div>
    </div>
  );
};

export default LoadingModal;
